import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EngagementSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {

    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className='EngagementSplash'>
      <div className={'esSection topSection'}>
        <div className='topLeftWrapper'>
          <div className='imgWrapper'>
            <img className='desktop600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/classic.jpg' />
            <img className='mobile600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/classic.jpg' />
          </div>
          <div className={'promptBox promptBoxTopLeft'}>
            <div className='promptImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/classic_prod.png' />
            </div>
            <div className='promptWrapper'>
              <div className='promptTitle'>Classic Style</div>
              <div className='promptCopy'>Known for their timeless look, classic settings will never go out of style.</div>
              <div className='promptButton' onClick={() => this.internalNav('setting/SMD1439174')}>Shop This Ring</div>
            </div>
          </div>
        </div>
        <div className='mobileSpacer'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/contemprorary_bw_m.jpg' />
        </div>
        <div className='topRightWrapper'>
          <div className={'promptBox promptBoxTopRight'}>
            <div className='promptImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/contemporary_product_a.png' />
            </div>
            <div className='promptWrapper'>
              <div className='promptTitle'>Contemporary Style</div>
              <div className='promptCopy'>Contemporary settings offer a distinctive and modern look to accentuate the center stone.</div>
              <div className='promptButton' onClick={() => this.internalNav('setting/SMD1414656')}>Shop This Ring</div>
            </div>
          </div>
          <div className='imgWrapper'>
            <img className='desktop600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/ringimage.jpg' />
            <img className='mobile600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/ringimage.jpg' />
          </div>
        </div>
      </div>
      <div className={'esSection middleSection'}>
        <div className='midLeftWrapper'>
          <img src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/vintage_1.jpg' />
        </div>
        <div className='midRightWrapper'>
          <div className='midRightImgWrapper'>
            <img className='desktop600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/vintage_bw.jpg' />
            <img className='mobile600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/vintage_bw_m.jpg' />
          </div>
          <div className={'promptBox promptBoxMid'}>
            <div className='promptImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/vintage_prod.png' />
            </div>
            <div className='promptWrapper'>
              <div className='promptTitle'>Vintage Style</div>
              <div className='promptCopy'>Vintage settings incorporate breathtaking details like art deco or milgrain.</div>
              <div className='promptButton' onClick={() => this.internalNav('setting/SMD1444401')}>Shop This Ring</div>
            </div>
          </div>
        </div>     
      </div>
      <div className={'esSection bottomSection'}>
        <div className='bottomLeftWrapper'>
          <div className='blImg'>
            <img className='desktop600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/kitehalo.jpg' />
            <img className='mobile600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/kitehalo_m.jpg' />
          </div>
          <div className={'promptBox promptBoxBottomLeft'}>
            <div className='promptImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/kitehalo_prod.png' />
              
            </div>
            <div className='promptWrapper'>
              <div className='promptTitle'>Decorative Kite Halo</div>
              <div className='promptCopy'></div>
              <div className='promptButton' onClick={() => this.internalNav('setting/SMD1435151')}>Shop This Ring</div>
            </div>
          </div>
        </div>
        <div className='bottomRightWrapper'>
          <div className='brImg'>
            <img className='desktop600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/accents.jpg' />
            <img className='mobile600' src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/mobile/accents_m.jpg' />
          </div>
          <div className={'promptBox promptBoxBottomRight'}>
            <div className='promptImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/engagement/splash/accents_prod.png' />
            </div>
            <div className='promptWrapper'>
              <div className='promptTitle'>Enchanting Diamond Accents</div>
              <div className='promptCopy'></div>
              <div className='promptButton' onClick={() => this.internalNav('setting/SMD1444399')}>Shop This Ring</div>
            </div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default EngagementSplash;

function mapStateToProps(state) {
  return {

  };
}

export const EngagementSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(EngagementSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/EngagementSplash.jsx